"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
const base_export_menu_1 = require("../export-menu/base-export-menu");
const material_1 = require("@angular/material");
const sis_report_export_dialog_1 = require("../report-export-dialog/sis-report-export.dialog");
const report_export_delimiter_dialog_1 = require("../report-export-delimiter-dialog/report-export-delimiter.dialog");
/**
 * Created by aghavni.grigoryan on 10/10/2017.
 */
let ReportExportMenuComponent = class ReportExportMenuComponent extends base_export_menu_1.BaseExportMenu {
    constructor(dialog) {
        super();
        this.dialog = dialog;
        // Enum which specified export types in report.
        this.ExportType = idm_report_export_service_client_js_1.ExportType;
        this.showOnlyCsv = false;
        this.export = new core_1.EventEmitter();
        this.pageOrientationChange = new core_1.EventEmitter();
        this.csvDelimiterChange = new core_1.EventEmitter();
    }
    onExportClick(exportType) {
        this.dialog.open(sis_report_export_dialog_1.SisReportExportDialog, {
            width: '500px',
            data: {
                selectedExportType: exportType,
                addPageOrientation: (orientation) => this.addPageOrientation(orientation),
                exportReport: () => this.exportReport(exportType)
            }
        });
    }
    openReportExportDelimiterDialog(exportType) {
        this.dialog.open(report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent, {
            width: '480px',
            data: {
                selectedExportType: exportType,
                addCsvDelimiter: (csvDelimiter) => this.addCsvDelimiter(csvDelimiter),
                exportReport: () => this.exportReport(exportType)
            }
        });
    }
    addPageOrientation(orientation) {
        this.pageOrientationChange.emit(orientation);
    }
    addCsvDelimiter(csvDelimiter) {
        this.csvDelimiterChange.emit(csvDelimiter);
    }
};
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ReportExportMenuComponent.prototype, "pageOrientationChange", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ReportExportMenuComponent.prototype, "csvDelimiterChange", void 0);
__decorate([
    core_1.Input('show-only-csv'),
    __metadata("design:type", Boolean)
], ReportExportMenuComponent.prototype, "showOnlyCsv", void 0);
ReportExportMenuComponent = __decorate([
    core_1.Component({
        
        selector: "sis-report-export-menu",
        styles: [require('./report-export-menu.component.css')],
        template: require('./report-export-menu.component.html')
    }),
    __metadata("design:paramtypes", [material_1.MatDialog])
], ReportExportMenuComponent);
exports.ReportExportMenuComponent = ReportExportMenuComponent;
//# sourceMappingURL=report-export-menu.component.js.map